import { NavLink, Outlet } from 'react-router';
import { copy } from '../../copy/en-CA.ts';

const s = copy.admin.sections;

/** The admin area: a section list beside the page on wide screens, above it on a phone. */
export function AdminLayout() {
  return (
    <div className="admin">
      <nav className="admin-nav" aria-label={copy.admin.title}>
        <NavLink to="/admin/todo">{s.todo}</NavLink>
        <NavLink to="/admin/build">{s.build}</NavLink>
        <NavLink to="/admin/schedules">{s.schedules}</NavLink>
        <NavLink to="/admin/distribution">{s.distribution}</NavLink>
        <NavLink to="/admin/availability">{s.availability}</NavLink>
        <NavLink to="/admin/physicians">{s.physicians}</NavLink>
        <NavLink to="/admin/users">{s.users}</NavLink>
        <NavLink to="/admin/audit">{s.audit}</NavLink>
        <NavLink to="/admin/export">{s.export}</NavLink>
      </nav>
      <div className="admin-body">
        <Outlet />
      </div>
    </div>
  );
}
